<div style="margin: 20px; min-height: 700px; min-width: 1200px;">
  <h2>Opcje dodatkowe</h2>
  <p-table [value]="features" [paginator]="true" [rows]="10">
    <ng-template pTemplate="header">
      <tr style="white-space: nowrap;">
        <th width="20%">Nazwa</th>
        <th width="60%">Opis</th>
        <th width="10%">Aktywna</th>
        <th width="10%">Akcje</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-f>
      <tr style="white-space: normal; overflow-wrap: break-word;">
        <td>{{f.name}}</td>
        <td>{{f.description}}</td>
        <td>
          <p-checkbox [(ngModel)]="checkedFeatures" [value]="f.id"></p-checkbox>
        </td>
        <td>
          <fa-stack *ngIf="checkedFeatures.includes(f.id)" size="1x" style="cursor: pointer; float: right;" (click)="selectOption(f)" title="Szczegóły">
            <fa-icon icon="square" stackItemSize="2x"></fa-icon>
            <fa-icon icon="edit" [inverse]="true" stackItemSize="1x"></fa-icon>
          </fa-stack>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div style="border-top: 10px;">
    <p-button class="button" routerLink="/validators" label="Zamknij"></p-button>
    <p-button class="button" (click)="save()" label="Zapisz"></p-button>
  </div>
</div>

<p-dialog *ngIf="feature" appendTo="body" header="Opcja: {{feature.name}}" [(visible)]="displayDlg" [modal]="true"  [responsive]="false">
  <p-table [value]="feature.featureParameters" [paginator]="true" [rows]="10">
    <ng-template pTemplate="header">
      <tr style="white-space: nowrap;">
        <th width="15%">Klucz parametru</th>
        <th width="55%">Opis</th>
        <th width="30%">Wartość</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-param>
      <tr style="white-space: normal; overflow-wrap: break-word;">
        <td>
          {{param.key}}
        </td>
        <td>
          {{param.description}}
        </td>
        <td>
          <!--input type="text" [value]="values[row.id]" (keyup)="changeParameter($event, row)" style="width: 100%;" /-->
          <input style="width: 100%" maxlength="255" pInputText [(ngModel)]="currentValidator.featureParametersMap[param.id].value" />
        </td>
      </tr>
    </ng-template>
  </p-table>
  <p-footer>
    <p-button (click)="displayDlg = false" label="Zapisz"></p-button>
    <p-button (click)="reset()" label="Zamknij"></p-button>
  </p-footer>
</p-dialog>
<!--input type="checkbox" name="checked" [checked]="featuresMap['' + row.id]" (change)="onSelect(row)" class="form-control"-->
